export default __webpack_public_path__ + "images/aq-e3fbc5d0ce77f1c9e808345d2bdd18ca.svg";